import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import moment from '../../../lib/moment.js'


import { Button } from 'reactstrap'
import { authSelector, positionSelector } from './../../../selectors'
import { positionAction } from './../../../actions/'
import CustomModalMessage from '../../../components/modal-message'
import PositionForm from '../../../components/position'

class CreatePosition extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      position_code: '',
      position: '',
      edit: false,
      id: '',
      activeTab: '1',
      start_date: '',
      is_active: '',
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.deactivatePosition = this.deactivatePosition.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
  }
  componentDidMount() {
    if (_.get(this.props, 'edit.edit')) {
      this.props.getPosition(_.get(this.props, 'edit.id'), localStorage.getItem('access_token'))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'positionGet')) {
      this.setState({
        position_code: _.get(nextProps, 'positionGet.position_code'),
        position: _.get(nextProps, 'positionGet.name'),
        start_date: _.get(nextProps, 'positionGet.start_date') ? _.get(nextProps, 'positionGet.start_date') : '',
        is_active: _.get(nextProps, 'positionGet.is_active'),
      })
      this.props.resetGetPosition()
    }
    if (_.get(nextProps, 'edit')) {
      if (_.get(nextProps, 'edit.edit')) {
        this.setState({
          id: _.get(nextProps, 'edit.id'),
          edit: false,
        })
        this.props.handleClickEdit(false, '')
        this.props.getPosition(_.get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetPosition()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDelete() {
    this.deactivatePosition()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  deactivatePosition() {
    this.props.deactivatePosition(_.get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  submitForm() {
    if (_.get(this.state, 'edit')) {
      this.props.editPosition(
        _.get(this.state, 'id'),
        {
          position_code: this.state.position_code,
          name: this.state.position,
          start_date: new moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
      <div>
        { _.get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ _.get(this.props, 'confirmType') === 'confirmDelete' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        { _.get(this.props, 'confirmType') === 'confirmDiscard' &&
        <CustomModalMessage
          hide={ this.props.cancelDiscard }
          show={ _.get(this.props, 'confirmType') === 'confirmDiscard' }
          type={ _.get(this.props, 'confirmStatus') }
          message={ _.get(this.props, 'confirmMessage') }
          button={ buttonDiscard }
        />
        }
        <PositionForm
          edit={ this.state.edit }
          position={ this.state.position }
          position_code={ this.state.position_code }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
          button={ button }
          confrim={ _.get(this.props, 'confirm') }
          handleInput={ this.handleInput }
          cancelForm={ this.props.cancelForm }
          handleSpan={ this.props.handleSpan }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

CreatePosition.propTypes = {
  createPosition: PropTypes.func.isRequired,
  editPosition: PropTypes.func.isRequired,
  getPosition: PropTypes.func.isRequired,
  resetGetPosition: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  deactivatePosition: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  positionCreate: positionSelector.getCreatePositionData,
  positionEdit: positionSelector.getEditPositionData,
  positionGet: positionSelector.getGetPositionData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createPosition: positionAction.createPosition,
  resetCreatePosition: positionAction.resetCreatePosition,
  editPosition: positionAction.editPosition,
  resetEditPosition: positionAction.resetEditPosition,
  getPosition: positionAction.getPositionByID,
  resetGetPosition: positionAction.resetGetPosition,
  listPosition: positionAction.getPosition,
  deactivatePosition: positionAction.deactivatePosition,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CreatePosition)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/position/edit/index.js